/**
 * @module public/js/useTenant.js
 * @summary Simple composable exposing the active tenant ID.
 *
 * @description
 * Lightweight helper that reads the current tenant ID from the
 * provided AuthService (defaults to the singleton from the DI container).
 * Controllers and services can import this to avoid reaching into
 * `auth.currentUser` directly. When no AuthService is provided, the helper
 * reads the runtime `globalThis.di` container instead of importing app
 * bootstrap, keeping Focus Mode's trimmed bootstrap graph intact.
 *
 * @param {import('./services/authservice.js').default=} authService
 * @returns {string|null} tenantId or null when unauthenticated
 */
import { resolveRuntimeDi } from './utils/runtimeDi.js';

export default function useTenant(authService = null) {
  const resolvedAuth = authService || resolveRuntimeDi().auth;
  return resolvedAuth?.currentUser?.tenantId ?? null;
}
